import * as React from "react";
import type { SVGProps } from "react";
const FilteredIcon = (props: SVGProps<SVGSVGElement>) => <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="1em" height="1em" fill="none" style={{
  userSelect: "none",
  flexShrink: 0
}} {...props}><path fill="currentColor" fillRule="evenodd" d="M12 21a9 9 0 1 0 0-18 9 9 0 0 0 0 18M8 8.75a.75.75 0 0 0 0 1.5h8a.75.75 0 0 0 0-1.5zm1 3a.75.75 0 0 0 0 1.5h6a.75.75 0 0 0 0-1.5zm1.25 3.75a.75.75 0 0 1 .75-.75h2a.75.75 0 0 1 0 1.5h-2a.75.75 0 0 1-.75-.75" clipRule="evenodd" /></svg>;
export default FilteredIcon;